import { createStyles } from "@mantine/core";

export const useStyles = createStyles(() => ({
  wrapper: {
    position: "relative",
  },
}));
